import React, { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import PhoneInput from 'react-phone-input-2';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';
import Wrapper from '../layouts/Wrapper';
import CareerCard from '../components/career/CareerCard';
import BottomPopup from '../components/BottomPopup';
import userIcon from '../assets/icons/userIcon.svg';
import emailIcon from '../assets/icons/emailGray.svg';
import DropDownIconTemplate from '../components/DropDownIconTemplate';
import 'react-phone-input-2/lib/style.css';
import uploadIcon from '../assets/icons/upload.svg';
import { getCareerPage, sendCareerCv } from '../store/actions/careerPage';
import Spinner from '../components/Spinner';
import removeHtmlTags from '../helpers/removeHtmlTags';

function Career() {
  const { translations } = useSelector((state) => state.translation);
  const lang = Cookies.get('i18next') || 'en';
  const [visible, setVisible] = useState(false);
  const [options, setOptions] = useState([]);
  const [selectedPosition, setSelectedPosition] = useState(options[1]);
  const [phone, setPhone] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const { data, loading } = useSelector((state) => state.careerPage);
  const [nameError, setNameError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [fileError, setFileError] = useState('');
  const [btnLoading, setBtnLoading] = useState(false);
  useEffect(() => {
    dispatch(getCareerPage());
  }, []);
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [visible]);
  const handleCloseModal = () => {
    setVisible(false);
  };
  const openModal = (id) => {
    setVisible(true);
    const selectedPosition1 = data.vacancies.map((e) => ({
      label: e.title[lang],
      id: e.id,
    })).find((e) => e.id === id);
    setSelectedPosition(selectedPosition1);
  };
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
    // setFileError('');
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile) {
      setFile(droppedFile);
    }
  };
  const handleSendCv = async (event) => {
    event.preventDefault();
    setBtnLoading(true);
    const { payload } = await dispatch(sendCareerCv({
      formData: {
        full_name: name,
        vacancy_id: selectedPosition.id,
        phone,
        email,
        lang,
        cv: file,
      },
      lang,
    }));
    if (payload.status === 'error') {
      if (payload?.messages?.phone) {
        setPhoneError(payload?.messages?.phone);
      }
      if (payload?.messages?.full_name) {
        setNameError(payload?.messages?.full_name);
      }
      if (payload?.messages?.email) {
        setEmailError(payload?.messages?.email);
      }
      if (payload?.messages?.cv) {
        setFileError(payload?.messages?.cv);
      }
    } else {
      setVisible(false);
      toast(translations.review_sent_successfully[lang]);
    }
    setBtnLoading(false);
  };
  useEffect(() => {
    if (data.vacancies) {
      setOptions(data.vacancies.map((e) => ({
        label: e.title[lang],
        id: e.id,
      })));
    }
  }, [data, lang]);
  useEffect(() => {
    setPhoneError('');
  }, [phone]);
  return (
    <Wrapper>
      {!loading ? (
        <>
          <Helmet>
            <title>
              {data.openVacancies && data.openVacancies.title && data.openVacancies.title[lang]}
            </title>
            {data.openVacancies && data.openVacancies.canonical_tags && (<link rel="canonical" href={data.openVacancies.canonical_tags[lang]} />)}
          </Helmet>
          <BottomPopup
            header={translations.application[lang]}
            visible={visible}
            handleCloseModal={handleCloseModal}
          >
            <div className="bottom-popup-form">
              <p className="bottom-popup-form-header">
                {translations.personal_information[lang]}
              </p>
              <form action="#" onSubmit={handleSendCv} className="modal-form">
                <div className="modal-input-container">
                  <div className="modal-input-block">
                    <label htmlFor="fullName" className="modal-input-block-label">
                      {translations.full_name_label[lang]}
                    </label>
                    <input
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                        setNameError('');
                      }}
                      placeholder={translations.full_name_placeholder[lang]}
                      type="text"
                      id="fullName"
                      className="modal-input-block-input"
                    />
                    <img src={userIcon} alt="user" className="modal-input-block-input-icon" />
                  </div>
                  {nameError && <p className="authError">{nameError}</p>}
                </div>
                <div className="modal-input-container">
                  <div className="modal-input-block">
                    <label htmlFor="position" className="modal-input-block-label">
                      {translations.position_label[lang]}
                      {' '}
                      *
                    </label>
                    {(options.length > 0 && selectedPosition) ? (
                      <Dropdown
                        panelClassName="locations-dropdown-panel modal"
                        itemTemplate={(e) => (
                          <div className="modal-input-dropdown-item">
                            <p className="modal-input-dropdown-item-text">
                              {e.label}
                            </p>
                          </div>
                        )}
                        dropdownIcon={() => <DropDownIconTemplate collapse={false} black />}
                        collapseIcon={() => <DropDownIconTemplate collapse black />}
                        className="modal-popup-select"
                        valueTemplate={(e) => (
                          <p className="modal-popup-value">{e.label}</p>
                        )}
                        value={selectedPosition}
                        onChange={(e) => setSelectedPosition(e.value)}
                        id="position"
                        options={options}
                      />
                    ) : null}
                  </div>
                </div>
                <div className="middle-block">
                  <div className="modal-input-container">
                    <div className="modal-input-block">
                      <label htmlFor="email" className="modal-input-block-label">
                        {translations.email_label[lang]}
                        *
                      </label>
                      <input
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          setEmailError('');
                        }}
                        placeholder={translations.email_placeholder[lang]}
                        type="text"
                        id="email"
                        className="modal-input-block-input"
                      />
                      <img src={emailIcon} alt="user" className="modal-input-block-input-icon" />
                    </div>
                    {emailError && <p className="authError">{emailError}</p>}
                  </div>
                  <div className="modal-input-container">
                    <div className="modal-input-block">
                      <label htmlFor="phone" className="modal-input-block-label">
                        {translations.phone[lang]}
                        *
                      </label>
                      <PhoneInput
                        id="phone"
                        country="am"
                        value={phone}
                        onChange={setPhone}
                        containerClass="phone-input-container"
                        inputClass="phone-input"
                        buttonClass="phone-input-button"
                        dropdownClass="phone-input-dropdown"
                      />
                      {phoneError && <p className="authError">{phoneError}</p>}
                    </div>
                  </div>
                </div>
                <div className="input-file-container">
                  <p className="modal-input-block-label">{translations.upload_cv[lang]}</p>
                  <input onChange={handleFileChange} type="file" id="file" />
                  <label
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                    htmlFor="file"
                    className="input-file-box"
                  >
                    <div className="input-file-icon">
                      <img src={uploadIcon} alt="" />
                    </div>
                    <div className="input-file-text-box">
                      <p className="input-file-text click">{translations.click_upload[lang]}</p>
                      <p className="input-file-text">{translations.drag_upload[lang]}</p>
                    </div>
                    <div className="input-file-types">
                      <p>SVG, PNG, JPG or GIF (max. 800x400px)</p>
                    </div>
                    {file && <p className="bottom-popup-form-header">{file.name}</p>}
                  </label>
                  {fileError && <p className="authError">{fileError}</p>}
                </div>
                <div className="modal-popup-actions">
                  <button
                    type="button"
                    onClick={handleCloseModal}
                    className="modal-popup-actions-button"
                  >
                    {translations.cancel[lang]}
                  </button>
                  <button
                    disabled={btnLoading}
                    type="submit"
                    className="modal-popup-actions-button confirm"
                  >
                    {btnLoading
                      ? <Spinner isBtn minWidth={80} size={15} width={50} height={20} />
                      : translations.confirm[lang]}
                  </button>
                </div>
              </form>
            </div>
          </BottomPopup>
          <div className="container small">
            <div className="career">
              <div className="career-info">
                <h1 className="career-info_title">{data.openVacancies.two_blog_title[lang]}</h1>
                <p className="career-info_description">
                  {removeHtmlTags(data.openVacancies.two_blog_description[lang])}
                </p>
              </div>
              <div className="career-list">
                {data.vacancies.map((item) => (
                  <CareerCard
                    key={item.id}
                    item={item}
                    openModal={() => openModal(item.id)}
                  />
                ))}
              </div>
            </div>
          </div>
        </>
      ) : <Spinner width={100} height={100} />}
    </Wrapper>
  );
}

export default Career;
